<template>
    <div class="container">
        <header class="f-bcf ">
            <div class="nameBox f-dfsb">
                <div>
                    <img class="back" v-show="isback" src="../assets/jxwx/arr_02.png" alt="" @click="backward()">
                    <span class="depName">{{data.wljx.groupname.group_name}}</span>
                </div>
            </div>

        </header>
        <div class="tabBox">
            <div class="f-back">
                    <ul class="performanceBox f-dfsb">
                        <li class="f-tal">
                            <div class="tt f-fs2 f-cl1">本月绩效累计(元)</div>
                            <div class="f-fs8">{{data.wljx.monthTotal.totalFee | moneyP}}</div>
                        </li>
                        <li class="f-tar">
                            <div class="tt f-fs2 f-cl1">昨日绩效(元)</div>
                            <div class="f-cl2 f-fs8">{{data.wljx.total.totalFee | moneyP}}</div>
                        </li>
                    </ul>
             </div>     

                    <section class="f-bcf f-mgb">
                        <van-tabs v-model="tabName" @click="handleClick">
                            <van-tab v-for="item in tabList" :key="item.id" :title=item.tt :name=item.tt></van-tab>
                        </van-tabs>
                        <ve-line :extend="chartExtend2" :data="chartData2" height="155px" :legend-visible="false"></ve-line>
                        <ul class="timeList">
                            <li v-for="(item,index) in timeList" :key="item.id" :class="{active:timeActive == index}" @click="timeChoose(index)">{{item.time}}</li>
                        </ul>
                    </section>

                    
                            <ul class="m-detailsList f-bcf">
                                <li>
                                    <div class="itemName">绩效项</div>
                                    <div class="cumMonth">本月累计</div>
                                    <div class="yesPer">
                                        <div>昨日绩效</div>
                                    </div>
                                </li>
                                <li>
                                    <div class="itemName">收货</div>
                                    <div class="cumMonth">{{data.shouhuo.monthTotal.totalFee | moneyP}}</div>
                                    <div class="yesPer">
                                        <div class="f-cl2">{{data.shouhuo.total.totalFee | moneyP}}</div>
                                    </div>
                                     <!-- <i class="arrow"></i>  -->
                                </li>
                                <li>
                                    <div class="itemName">补货</div>
                                    <div class="cumMonth">{{data.buhuo.monthTotal.totalFee | moneyP}}</div>
                                    <div class="yesPer">
                                        <div class="f-cl2">{{data.buhuo.total.totalFee | moneyP}}</div>
                                    </div>
                                     <!-- <i class="arrow"></i>  -->
                                </li>
                                <li>
                                    <div class="itemName">拣货</div>
                                    <div class="cumMonth">{{data.jianhuo.monthTotal.totalFee | moneyP}}</div>
                                    <div class="yesPer">
                                        <div class="f-cl2">{{data.jianhuo.total.totalFee | moneyP}}</div>
                                    </div>
                                     <!-- <i class="arrow"></i>  -->
                                </li>
                                <li>
                                    <div class="itemName">其他</div>
                                    <div class="cumMonth">{{data.qita.monthTotal.totalFee | moneyP}}</div>
                                    <div class="yesPer">
                                        <div class="f-cl2">{{data.qita.total.totalFee | moneyP}}</div>
                                    </div>
                                     <!-- <i class="arrow"></i>  -->
                                </li>
                            </ul>
                        
             
        </div>

    </div>
</template>

<script>
import { wlapi } from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.getResultByGroup(this.groupId, this.date);
                }
            }
        }
    },
    data() {
        return {
            
            tabName: "全部",
            timeActive: 0,
       
            chartExtend2: {
                grid: {
                    x: 20,
                    y: 20,
                    x2: 25,
                    y2: 5
                },
                series: {
                    symbol: "none",
                    lineStyle: {
                        normal: {
                            color: "#0898EA"
                        }
                    }
                },
                xAxis: {
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#dedede"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    }
                },
                yAxis: {
                    axisTick: {
                        //y轴刻度线
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    },
                    splitLine: {
                        //网格线
                    }
                }
            },

            
            chartData2: {
                columns: ["日期", "绩效"],
                rows: []
            },
            tabList: [
                {
                    tt: "全部"
                },
                {
                    tt: "收货"
                },
                {
                    tt: "补货"
                },
                {
                    tt: "拣货"
                },
                {
                    tt: "其他"
                }
            ],
            timeList: [
                {
                    time: "近1月"
                },
                // {
                //     time: "近3月"
                // },
                {
                    time: "近6月"
                },
                {
                    time: "近1年"
                }
            ],
            data: {},
            groupId: this.$route.query.business_id,
            date: this.$route.query.endtime,
            isback: this.$route.query.isback,

            classData: [],
            monthdayList: [],
            sixMonthList: [],
            yearList: [],
            show: false
        };
    },
    filters: {
        nameP: function(value) {
            if (value) {
                return value.split("(")[0];
            }
        }
    },
    // filters: {
    //     moneyP: function(value) {
    //         if (value != undefined) {
    //             // var num = Math.round(value*100)/100;
    //             if (value != 0) {
    //                 var value = Math.round(parseFloat(value) * 100) / 100;
    //                 var xsd = value.toString().split(".");
    //                 if (xsd.length == 1) {
    //                     value = value.toString() + ".00";
    //                     var val = value;
    //                 }
    //                 if (xsd.length > 1) {
    //                     if (xsd[1].length < 2) {
    //                         value = value.toString() + "0";
    //                     }
    //                     var val = value;
    //                 }
    //                 var str = val.toString();
    //                 var reg =
    //                     str.indexOf(".") > -1
    //                         ? /(\d)(?=(\d{3})+\.)/g
    //                         : /(\d)(?=(?:\d{3})+$)/g;
    //                 return str.replace(reg, "$1,");
    //             } else {
    //                 return "0.00";
    //             }

    //             // return Number(value.toString().match(/^\d+(?:\.\d{0,2})?/));
    //         }
    //     }
    // },
mounted() {
        // this.getResultByGroup(this.groupId, this.date);
    },
    methods: {
        handleClick(name) {
            this.classData = [];
            switch (this.tabName) {
                case "全部":
                    this.monthdayList = this.data.wljx.monthCurve;
                    this.sixMonthList = this.data.wljx.sixMonthCurve.reverse();
                    this.yearList = this.data.wljx.yearCurve.reverse();
                    break;
                case "收货":
                    this.monthdayList = this.data.shouhuo.monthCurve;
                this.sixMonthList = this.data.shouhuo.sixMonthCurve.reverse();
                this.yearList = this.data.shouhuo.yearCurve.reverse();
                    break;
                case "补货":
                    this.monthdayList = this.data.buhuo.monthCurve;
                this.sixMonthList = this.data.buhuo.sixMonthCurve.reverse();
                this.yearList = this.data.buhuo.yearCurve.reverse();
                    break;
                case "拣货":
                    this.monthdayList = this.data.jianhuo.monthCurve;
                this.sixMonthList = this.data.jianhuo.sixMonthCurve.reverse();
                this.yearList = this.data.jianhuo.yearCurve.reverse();
                    break;
                case "其他":
                    this.monthdayList = this.data.qita.monthCurve;
                this.sixMonthList = this.data.qita.sixMonthCurve.reverse();
                this.yearList = this.data.qita.yearCurve.reverse();
                    break;
            }
            this.lineData(this.tabName);
        },
        timeChoose(index) {
            this.timeActive = index;
            this.classData = [];
            this.lineData(this.tabName);
        },
        lineData(itemName) {
            switch (this.timeActive) {
                case 0:
                    this.monthdayList.forEach(item => {
                        this.itemChoose(itemName, item);
                    });
                    this.chartData2.rows = this.classData;
                    break;
                case 1:
                    this.sixMonthList.forEach(item => {
                        this.itemChoose2(itemName, item);
                    });
                    this.chartData2.rows = this.classData;
                    break;
                case 2:
                    this.yearList.forEach(item => {
                        this.itemChoose2(itemName, item);
                    });
                    this.chartData2.rows = this.classData;
                    break;
            }
        },
        itemChoose(itemName, item) {
           
           var i = {
                        日期: item.feeDate,
                        绩效: item.totalFee
                    };
                    this.classData.push(i);
        },
        itemChoose2(itemName, item) {
            var i = {
                        日期: item.month,
                        绩效: item.totalFee
                    };
                    this.classData.push(i);
        },
        
        getResultByGroup(groupId, time) {
            let par = {
                business_id: groupId,
                endtime: time
            };
            wlapi.getDetail(par).then(res => {
                this.data = res.result;
                this.monthdayList = this.data.wljx.monthCurve;
                this.sixMonthList = this.data.wljx.sixMonthCurve.reverse();
                this.yearList = this.data.wljx.yearCurve.reverse();
                this.lineData(this.tabName);
            });
        },
        backward() {
            this.$router.backward();
        },

        
    },
    
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.container {
    margin-bottom: 60px;
}
.nameBox {
    .back {
        width: 2vw;
        margin-right: 2.6vw;
    }
    margin: 0 4.8vw;
    height: 12.8vw;
    // border-bottom: 1px solid #dedede;
    .depName {
        font-size: 18px;
    }
    .docName {
        font-size: 13px;
        color: #a6a6a6;
    }
}
.f-back{
    background: #fff;
}
.performanceBox {
    margin: 0 4.8vw 10px 4.8vw;
    padding: 3.2vw 0 1.8vw 0;
    background: #fff;
    border-top:1px solid #dedede;
    li {
        padding: 1.3vw 0;
        .tt {
            margin-bottom: 2.6vw;
        }
    }
}


.tabBox {
    /deep/.tabWrap {
        & > .van-tabs__wrap {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            border-top: 1px solid #dedede;
            border-bottom: none;
            z-index: 999;
            .van-tab--active {
                background: #e5323b;
                color: #fff;
            }
            .van-tabs__line {
                height: 0;
            }
        }
    }
}
.van-tabs {
    /deep/.van-tabs__wrap {
        border-bottom: 1px solid #dedede;
    }
    /deep/.van-tab--active {
        color: #e5323b;
    }
    /deep/.van-tabs__line {
        width: 10.4vw !important;
    }
    .rankBox {
        // height: 32.6vw;
        background-color: #fff;
        .rangeList {
            li {
                display: flex;
                align-items: center;
                height: 10.6vw;
                div {
                    flex: 1;
                    text-align: center;
                    font-size: 14px;
                }
                .date {
                    color: #a6a6a6;
                }
            }
            li:first-child {
                font-size: 13px;
                color: #a6a6a6;
                background-color: #fafcff;
                border-bottom: 1px solid #dedede;
            }
        }
    }
}
.timeList {
    display: flex;
    background-color: #fafcff;
    height: 9.2vw;
    font-size: 13px;
    color: #a6a6a6;
    li {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        border-top: 1px solid #dedede;
    }
    li.active {
        color: #2c2c2c;
        background-color: #fff;
        border-top: 1px solid #fff;
        border-right: 1px solid #dedede;
        border-left: 1px solid #dedede;
    }
    li:first-child.active {
        border-left: none;
    }
    .customizeBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 14.6vw;
        height: 6.4vw;
        line-height: 1;
        border: 1px solid #0897ea;
        border-radius: 6px;
        color: #0897ea;
        box-sizing: border-box;
    }
}
.detailsTab {
    /deep/.van-tab {
        font-size: 16px;
    }
}

.m-detailsList {
    li {
        position: relative;
        display: flex;
        align-items: center;
        height: 14.5vw;
        margin: 0 4vw;
        font-size: 15px;
        border-bottom: 1px solid #dedede;
        div {
            flex: 1;
            text-align: center;
        }
        .itemName {
            text-align: left;
        }
        .yesPer {
            text-align: right;
            div {
                display: inline-block;
                width: 20vw;
            }
        }
        i {
            position: absolute;
            right: 0;
            display: inline-block;
            width: 2vw;
            height: 3.6vw;
            background: url(../assets/jxwx/arr_03.png) no-repeat;
            background-size: 100% 100%;
        }
    }
    li:first-child {
        margin: 0;
        height: 10.9vw;
        padding: 0 4vw;
        background-color: #fafcff;
        font-size: 13px;
        color: #a6a6a6;
        border-bottom: 1px solid #d4e5ff;
        .itemName {
            padding-left: 2px;
        }
    }
    li:last-child {
        border-bottom: none;
    }
}

.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 3.3vw;
    color: #fff;
    background: #5584ff;
    .f-dfsb {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .time {
        font-size: 12px;
    }
    .daytotal {
        font-size: 21px;
    }
    .tt {
        margin-left: 4vw;
    }
}
.detailList {
    padding: 0 3.3vw;
    color: #fff;
    background: #5584ff;
    .name {
        margin-left: 0.3vw;
        font-size: 16px;
    }
    .tt {
        margin-right: 1.7vw;
        font-size: 12px;
        color: #a6bdfa;
    }
    .drop_down {
        .listBox {
            overflow: hidden;
        }
        .drop_list {
            padding: 4vw 0 0 0;
            li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 3.2vw;
                border: 1px solid #2e68ff;
                border-radius: 6px;
                div {
                    flex: 1;
                    text-align: center;
                    p:first-child {
                        margin: 2vw 0 1vw 0;
                        font-size: 13px;
                    }
                    p:last-child {
                        margin: 1vw 0 2vw 0;
                        font-size: 12px;
                    }
                }
            }
            .f-mb0 {
                margin: 0;
            }
        }
    }
}
.imgBox {
    padding: 2vw 0;
    text-align: center;
    .dropImg {
        width: 2vw;
        height: 1vw;
    }
}
.control_box {
    display: flex;
    margin: 3.7333vw 2.5333vw;
    background: #f5e6d0;
    border-radius: 6px;
}
.control_box2 {
    margin: 0;
    background: #91c619;
    border-radius: 0;
}
.control_box > ul {
    flex: 1;
    text-align: center;
    padding-bottom: 3.0667vw;
}
.control_box > ul > .tt {
    padding: 3.4667vw 0 2.6667vw 0;
    font-size: 12px;
    color: #afafaf;
}
.control_box2 > ul > .tt {
    padding: 4.2667vw 0 3.2vw 0;
    font-size: 12px;
    color: #def0b6;
}
.control_box > ul > .num {
    padding: 0 0 2.1333vw 0;
    font-size: 21px;
    color: #f56b18;
}
.control_box2 > ul > .num {
    padding: 0 0 1.7333vw 0;
    color: #fff;
}
.control_box > ul > .per {
    width: 20.9333vw;
    margin: 0 auto;
    padding: 0.8vw 0;
    border: 1px solid rgba(196, 196, 196, 1);
    border-radius: 5px;
    font-size: 10px;
    color: #f56b18;
}
.control_box2 > ul > .per {
    width: 19.0667vw;
    margin: 0 auto;
    padding: 1.6vw 0;
    border: 1px solid #d9edaf;
    border-radius: 5px;
    font-size: 13px;
    color: #fff;
}

.line {
    margin: 0 -4vw;
    border-bottom: 1px solid #d4d4d4;
}
.lineName{
    display: flex;
    align-items: center;
    margin: 0;
    padding: 2vw;

    img{
        width: 4vw;
        margin-right: 1.6vw;
    }
}
.u-card {
    margin: 2.6vw 4vw 0 4vw;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    // border-radius: 6px;
}
.cardBox {
    .hd {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            align-items: center;
            img {
                margin-right: 1.6vw;
            }
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 2vw 0 1.4vw 0;
        .m-hos {
            width: 50%;
            padding: 0 2vw;
            box-sizing: border-box;
            .f-df {
                display: flex;
                align-items: center;
            }
        }
        // .m-hos2 {
        //     width: 42vw;
        //     padding: 0 ;
        // }
        .m-hos header {
            margin-bottom: 3.4667vw;
            font-size: 14px;
            color: #4c4c4c;
        }
        .m-hos header img {
            width: 1.3333vw;
            margin-right: 1.3333vw;
        }
        .m-hos .progress {
            width: 100%;
            height: 2.1333vw;
            margin-bottom: 2.6667vw;
            border-radius: 1.0667vw;
            background-color: #efefef;
            overflow: hidden;
            .progress_bar {
                height: 100%;
                background-color: #fed100;
            }
            .progress_bar2 {
                height: 100%;
                background-color: #91c619;
            }
            .progress_bar3 {
                height: 100%;
                background-color: #f66969;
            }
        }

        .m-hos .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3.2vw;
            font-size: 12px;
        }
        .m-hos > .entry > .ctt {
            color: #8f8f8f;
        }
        .m-hos > .entry > .nm {
            font-size: 13px;
            color: #282828;
        }
        .m-hos > .entry > .mark {
            color: #f66969;
            // background: #fff;
        }
        .m-hos > .entry > .mark2 {
            color: #91c619;
        }
    }
}
.f-bc {
    padding: 2.6vw 0;
    background: #f7f7f7;
    .u-card {
        margin: 2.6vw 4vw;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
        border-radius: 6px;
    }
    .cardBox {
        .hd {
            display: flex;
            font-size: 13px;
            justify-content: start;
            align-items: center;
            height: 12vw;
            padding: 0 4vw;
            border-bottom: 1px solid #dedede;
            .icon {
                width: 4vw;
            }
            .tt {
                display: flex;
                justify-content: space-between;
                width: 45vw;
                margin: 0 3.2vw 0 1.6vw;
            }
            .arr {
                width: 1.3vw;
            }
        }
        .bd {
            display: flex;
            justify-content: space-between;
            padding: 4vw;
            .tt {
                margin-bottom: 3.2vw;
                font-size: 13px;
                color: #a6a6a6;
            }
            .num {
                font-size: 18px;
            }
        }
    }
}

.draw-enter-active,
.draw-leave-active {
    height: 34.8vw;
    opacity: 1;
    transition: all 0.5s;
}
.draw-enter,
.draw-leave-to {
    height: 0;
    opacity: 0;
}

.personBox {
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/wljx/whTeamLeader.vue